import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {component_tool} from '../../../../tool'
import {WizDataAuthSelect} from '@/containers/common'

let {WizButton, WizSpin, WizAntdForm, WizRow, WizCol} = component_tool

class ApplyAuthSelect extends Component {

  componentName = 'applyAuthSelect';

  constructor(props) {
    super(props);
    this.state = {
      applyStatus: 0
    }
  }

  _onReset = () => {
    this.props.form.resetFields()
  }

  _prev = (prevFunc) => {
    if (prevFunc) {
      this.props.prevFunc && this.props.prevFunc()
    }
  }
  _applyOnRelease(flag) {
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let {submit} = this.props
        submit && submit(values, flag)
      }
    });
  }

  render() {
    let {form, loading, initialValue,prevFunc} = this.props
    return (
      <WizSpin tip={'加载中'} spinning={loading}>
        <WizAntdForm>
          {
            form.getFieldDecorator('dataAuth', {initialValue:Object.assign({}, initialValue)})(
              <WizDataAuthSelect isNotAuth={true} />
            )
          }
          <WizAntdForm.Item wrapperCol={{span: 12, offset: 6}}>
            <WizRow className="form-btns row-item">
              <WizCol span={24} style={{textAlign: 'center'}}>
                <WizButton title="上一步" onClick={e => this._prev(prevFunc)}>上一步</WizButton>
                <WizButton type="primary" htmlType="submit" onClick={e => this._applyOnRelease(true)}>
                  保存并发布
                </WizButton>
                <WizButton htmlType="submit" onClick={e => this._applyOnRelease(false)}>
                  保存并返回
                </WizButton>
                <WizButton title='重置' type='reset' onClick={this._onReset}>重置</WizButton>
              </WizCol>
            </WizRow>
          </WizAntdForm.Item>
        </WizAntdForm>
      </WizSpin>
    )
  }
}

export default WizAntdForm.create()(ApplyAuthSelect);

/**
 * 默认值
 */
ApplyAuthSelect.defaultProps = {
  title: '数据权限选择',
  loading: false
}
/**
 * props入参校验
 */
ApplyAuthSelect.propTypes = {
  submit: PropTypes.fun,//提交的回调方法
  loading: PropTypes.bool
}
